import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import IconCheckMark from '@components/Images/Rebranding/IconCheckMark';

interface StepCompleteProps {
  nextStep: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const StepComplete = ({ nextStep }: StepCompleteProps) => (
  <div className="onboarding-content center mb-36">
    <div>
      <div className="onboarding-icon">
        <IconCheckMark className="h-1/2 text-primary-magenta" />
      </div>
      <h2 className="onboarding-heading large">You’re All Set!</h2>
      <p className="mt2 mb3">
        Check your inbox from The Information and enjoy reading the best in tech news.
      </p>
      <PrimaryButton as="button" onClick={nextStep} size="small" fullWidth>
        Close
      </PrimaryButton>
    </div>
  </div>
);

export default StepComplete;
